import { MDBDataTable } from "mdbreact"
import React, { useEffect, useRef, useState } from "react"
import MetaTags from "react-meta-tags"
import { Col, Container, Row, Alert } from "reactstrap"
import { Link } from "react-router-dom"

const Configurations = () => {
    const columns = [
        {label: "#", field: "number"},
        {label: "Configuration", field: "config"},
        {label: "Manage", field: "manage"},
    ]

    const rows = [
        {
            number: 1,
            config: "Application Consumption Areas",
            manage: <Link to={"consumption-areas" }>
            <i className="ti-settings" title="Review"></i>{" Manage"}
          </Link> 
        }
    ]

    const data = {
        columns: columns,
        rows: rows
    }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Configurations</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Configurations</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    As admin, you will make custom configurations to the system via this page.
                  </li>
                </ol>
              </Col>
            </Row>

            <Row>
                <MDBDataTable data={data} />
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Configurations
